import React from 'react';
import { ConfigProvider, DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/es';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import locale from 'antd/es/locale/es_ES';
import useDataTravel from "../../../hooks/useDataTravel";

const DateRange = (props) => {
    const { onDataChange, value, isValid, setIsValid, availableTimes } = props;
    const { data, loading, error } = useDataTravel();
    const { date1, date2 } = data;
    const dateFormat = availableTimes && availableTimes.length > 0 ? 'DD/MM/YY HH:mm' : 'DD/MM/YY';
    const MIN_DAYS = 3;

    dayjs.extend(customParseFormat);
    dayjs.extend(utc)

    const handleDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = availableTimes && availableTimes.length > 0
                ? dayjs(date).format("YYYY-MM-DDTHH:mm")
                : dayjs(date).format("YYYY-MM-DD");
            onDataChange(formattedDate);
            setIsValid(true);
        } else {
            onDataChange('')
            setIsValid(false);
        }
    };

    const processedTimes = availableTimes.reduce((acc, time) => {
        const [hour, minute] = time.split(':').map(Number);
        if (!acc[hour]) {
            acc[hour] = [];
        }
        acc[hour].push(minute);
        return acc;
    }, {});

    const disabledTime = () => {
        if (!availableTimes || availableTimes.length === 0) {
            return {};
        }

        const allowedHours = Object.keys(processedTimes).map(Number);


        return {
            disabledHours: () => {
                const hours = [];
                for (let i = 0; i < 24; i++) {
                    if (!allowedHours.includes(i)) {
                        hours.push(i);
                    }
                }
                return hours;
            },
            disabledMinutes: (selectedHour) => {
                const allowedMinutes = processedTimes[selectedHour] || [];
                return Array.from({ length: 60 }, (_, i) => i).filter(min => !allowedMinutes.includes(min));
            },
        };
    };

    const disabledDate= (current) => {
        const threeDaysFromNow = dayjs().utc().startOf('day').add(MIN_DAYS, 'day');
        const minDate = dayjs.utc(date1, 'DD/MM/YY');
        const maxDate = dayjs.utc(date2, 'DD/MM/YY').add(1, 'day');


        return (
            (current && current < threeDaysFromNow) ||
            (current && current < minDate) ||
            (current && current > maxDate)
        );
    }


    return (
        <div className='input-datepicker'>
            <ConfigProvider locale={locale}>
                <Space direction="vertical">
                    <DatePicker
                        className='input-datepicker__self'
                        placeholder="dd/mm/aa"
                        format={{
                            format: dateFormat,
                        }}
                        showTime={
                            availableTimes && availableTimes.length > 0
                                ? {
                                    format: 'HH:mm',
                                    disabledTime,
                                    hideDisabledOptions: true,
                                    changeOnScroll: true,
                                    needConfirm: false,
                                }
                                : false
                        }
                        value={value ? dayjs.utc(value) : null}
                        status={!isValid ? 'error' : ''}
                        onChange={handleDateChange}
                        minDate={dayjs.utc(date1, 'DD/MM/YY')}
                        maxDate={dayjs.utc(date2, 'DD/MM/YY')}
                        //disabledDate={current => current && current < dayjs().utc().startOf('day')}
                        disabledDate={disabledDate}
                        placement='top'
                        inputReadOnly={true}
                    />
                </Space>
            </ConfigProvider>
        </div>
    );
};

export default DateRange;
